import {
  query,
  collection,
  where,
  orderBy,
  onSnapshot
} from 'firebase/firestore';
import { Firestore } from '../Firebase';
import Zone, { zoneConverter } from '../model/Zone';

export function subscribeToZones(
  parent: string | null,
  onNext: (zones: Zone[]) => void,
  onError?: (error: Error) => void,
  onCompletion?: () => void,
  isPrivileged: boolean = false
) {
  const colRef = collection(Firestore, 'zones').withConverter(zoneConverter);
  let colQuery = query(colRef, where('parent', '==', parent));

  if (!isPrivileged) {
    colQuery = query(colQuery, where('public', '==', true))
  }

  colQuery = query(colQuery, orderBy('order'));

  return (
    onSnapshot(colQuery,
      querySnapshot => onNext(querySnapshot.docs.map(doc => doc.data())),
      onError,
      onCompletion
    )
  );
}

